<script setup>
import { GM_DESTINATIONS } from '@/data/destinations';
import { u } from '@/data/images';
import vReveal from '@/directives/reveal';
</script>

<template>
  <section class="destinations" id="destinations">
    <div class="wrap">
      <div class="section-head" v-reveal>
        <span class="eyebrow">Featured Destinations</span>
        <h2>Where will your story begin?</h2>
        <p>Eleven signature destinations across the north, the coast and the great lakes — each one unforgettable.</p>
      </div>
      <div class="masonry">
        <router-link
          v-for="d in GM_DESTINATIONS"
          :key="d.id"
          :class="['gm-dest', d.size === 'xtall' ? 'gm-dest--xtall' : 'gm-dest--tall']"
          :to="{ name: 'destination', params: { id: d.id } }"
          v-reveal
        >
          <img class="gm-dest__img" :src="u(d.hero, 800)" :alt="d.name" loading="lazy" />
          <div class="gm-dest__body">
            <span class="gm-dest__eyebrow">{{ d.region }}</span>
            <h3 class="gm-dest__name">{{ d.name }}</h3>
            <p class="gm-dest__desc">{{ d.short }}</p>
            <span class="gm-dest__cta">Explore <span aria-hidden="true">→</span></span>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>
